import { Currency, EmploymentStatus } from "@nemuru-eng/js-api-client";
import { parseStringAmountWithUnitToNumber } from "../formaters";

export const ProfessionalDetailsMapper = {
  dehydrate(data) {
    const seniorityDays = Math.ceil(
      (new Date() - data.companySeniority) / (1000 * 60 * 60 * 24)
    );
    const seniorityYears = Math.floor(seniorityDays / 12 / 30);
    const seniorityMonths = Math.round(
      (seniorityDays / 12 / 30 - seniorityYears) * 12
    );

    return {
      id: data.id,
      loan_id: data.loanId,
      professional_details: {
        employment_status: data.employmentStatus,
        professional_position: data.professionalPosition || null,
        company_info: data.companyActivity
          ? {
              activity: data.companyActivity,
              name: data.companyName,
              phone_number: null,
              city: data.companyCity,
              seniority_months: seniorityMonths,
              seniority_years: seniorityYears,
              corporate_id_number: data.corporateIdNumber || null,
            }
          : null,
        ...(data.employmentStatus === EmploymentStatus.SELF_EMPLOYED &&
        data.selfEmploymentNetIncomeDate &&
        data.selfEmploymentNetIncomeValue
          ? {
              self_employment_net_income: {
                value: {
                  amount: parseStringAmountWithUnitToNumber(
                    data.selfEmploymentNetIncomeValue
                  ),
                  currency: Currency.EUR,
                },
                date: `${data.selfEmploymentNetIncomeDate.getFullYear()}-12-31T00:00:00+00:00`,
              },
            }
          : {}),
      },
    };
  },
};
